/**
 * ============================================================================
 * PERSONALIZACIÓN BØLG — sistema nativo (reemplaza Zepto)
 * Combinaciones: Nombre + ilustración | Nombre + iniciales | Solo ilustración.
 * - Centro de la botella: ilustración (imagen) O iniciales (texto grande).
 * - Abajo: el nombre. Iniciales y nombre tienen cada uno su tipografía.
 * - Cobro: conmuta la opción real del producto (Sin/Con) vía [data-variant-input].
 * ============================================================================
 */
(function () {
  'use strict';

  var NAME_RE = /^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ0-9 .'\-]+$/;
  var INI_RE = /^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ]+$/;
  // Elimina en vivo cualquier caracter no permitido (emojis, símbolos, etc.)
  var NAME_STRIP = /[^A-Za-zÁÉÍÓÚÜÑáéíóúüñ0-9 .'\-]/g;
  var INI_STRIP = /[^A-Za-zÁÉÍÓÚÜÑáéíóúüñ]/g;
  function cpLen(s) { return Array.from(s || '').length; }

  function loadGoogleFont(param) {
    if (!param) return;
    var id = 'bolg-font-' + param.replace(/[^a-z0-9]/gi, '');
    if (document.getElementById(id)) return;
    var l = document.createElement('link');
    l.id = id; l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=' + param + '&display=swap';
    document.head.appendChild(l);
  }

  function init() {
    var container = document.querySelector('[data-personalization]');
    if (!container || container.dataset.bolgInit === '1') return;
    container.dataset.bolgInit = '1';

    // Neutralizar el personalizador viejo (Zepto) en productos con el nativo. Ocultarlo por CSS no
    // basta: su <select> "required" vacío hace que el navegador bloquee "Agregar al carro".
    // Deshabilitamos sus campos (los disabled no validan ni se envían). Zepto carga async, así que
    // reintentamos y observamos el DOM. Lo ideal igual es sacar estos productos de Zepto.
    (function () {
      function killZepto() {
        var z = document.querySelector('.product-personalizer');
        if (!z) return false;
        var f = z.querySelectorAll('input, select, textarea');
        if (!f.length) return false;
        for (var i = 0; i < f.length; i++) { f[i].disabled = true; f[i].removeAttribute('required'); }
        return true;
      }
      if (!killZepto() && 'MutationObserver' in window) {
        var obs = new MutationObserver(function () { if (killZepto()) obs.disconnect(); });
        obs.observe(document.body, { childList: true, subtree: true });
        setTimeout(function () { obs.disconnect(); }, 6000);
      }
    })();

    var form = container.closest('form');
    var maxChars = parseInt(container.dataset.maxChars, 10) || 12;
    var maxIni = parseInt(container.dataset.maxIniciales, 10) || 3;
    var persoOn = container.dataset.persoOn || 'Con';
    var persoOff = container.dataset.persoOff || 'Sin';
    var persoImgIndex = parseInt(container.dataset.persoImgIndex, 10);

    var nameInput = container.querySelector('[data-perso-input]');
    var nameCounter = container.querySelector('[data-perso-counter]');
    var nameError = container.querySelector('[data-perso-error]');
    var iniInput = container.querySelector('[data-perso-ini-input]');
    var iniCounter = container.querySelector('[data-perso-ini-counter]');
    var iniError = container.querySelector('[data-perso-ini-error]');

    var tipoBtns = container.querySelectorAll('[data-perso-tipo]');
    var iluBtns = container.querySelectorAll('[data-perso-ilu]');
    var nameFontBtns = container.querySelectorAll('[data-perso-font]');
    var iniFontBtns = container.querySelectorAll('[data-perso-font-ini]');
    var orientBtns = container.querySelectorAll('[data-perso-orient]');
    var orientWrap = container.querySelector('[data-perso-orient-wrap]');
    var priceBox = container.querySelector('[data-perso-pricebox]');

    var secIlu = container.querySelector('[data-perso-section="ilustracion"]');
    var secIni = container.querySelector('[data-perso-section="iniciales"]');
    var secNom = container.querySelector('[data-perso-section="nombre"]');

    var props = {
      tipo: container.querySelector('[data-prop-tipo]'),
      flag: container.querySelector('[data-prop-flag]'),
      iluNombre: container.querySelector('[data-prop-ilu-nombre]'),
      iniFontNombre: container.querySelector('[data-prop-inifont-nombre]'),
      fontNombre: container.querySelector('[data-prop-font-nombre]'),
      marca: container.querySelector('[data-prop-marca]'),
      orient: container.querySelector('[data-prop-orient]'),
      preview: container.querySelector('[data-prop-preview]')
    };

    var preview = document.querySelector('[data-personalization-preview]');
    var pvIlu = preview ? preview.querySelector('[data-preview-illustration]') : null;
    var pvIni = preview ? preview.querySelector('[data-preview-initials]') : null;
    var pvName = preview ? preview.querySelector('[data-preview-name]') : null;

    // Mini-preview flotante (mobile)
    var miniCard = container.querySelector('[data-perso-mini]');
    var pvIluMini = container.querySelector('[data-preview-illustration-mini]');
    var pvIniMini = container.querySelector('[data-preview-initials-mini]');
    var pvNameMini = container.querySelector('[data-preview-name-mini]');

    var persoSelect = form ? form.querySelector('.variant-input-wrap[data-handle*="personaliz"] [data-variant-input]') : null;

    // Zoom a la zona de grabado al personalizar
    var pvWrap = preview ? preview.closest('.image-wrap') : null;
    var pvMain = preview ? preview.closest('.product-image-main') : null;
    function setZoom(on) {
      if (!pvWrap) return;
      if (pvMain) pvMain.style.overflow = on ? 'hidden' : '';
      pvWrap.style.transition = 'transform .45s ease';
      pvWrap.style.transformOrigin = '50% 64%';
      pvWrap.style.transform = on ? 'scale(1.7)' : '';
    }

    var state = { tipo: '', ilu: null, iniFont: null, nameFont: null, orient: 'Horizontal' };

    // === MEDIDAS REALES DEL LÁSER ============================================
    // Fuente: PDF de producción + una botella grabada de verdad medida con regla.
    var ILU_CM = 4.2;               // caja de ilustración (el PDF dice 5,5 max)
    var NOM_ALTO_CM = 0.9;          // alto de la caja del nombre = el tamaño de letra
                                    // ("un pelo más chica", producción 20-ago)
    var NOM_MAX_CM = 6;             // ancho MÁXIMO del nombre (Zermatt 6,5)
    // La botella es un CILINDRO: los cm del PDF van a lo largo de la superficie
    // curva, pero la foto muestra la proyección plana, que es menor. Un nombre de
    // 6 cm sobre un cuerpo de 6,5 cm de diámetro se ve de frente como 5,18 cm.
    // Sin esto los nombres largos parecían salirse de la botella.
    var DIAM_CM = 6.5;
    function proyectar(cm) { return DIAM_CM * Math.sin(Math.min(cm / DIAM_CM, Math.PI / 2)); }
    var CUERPO_TOP = 0.309, CUERPO_BOT = 0.884;
    var CM_POR_SPAN = 0.06073;
    var MARGEN_ABAJO_CM = 0.9, SEP_CM = 1.5;
    var _top = parseFloat(container.dataset.posTop);
    var _bot = parseFloat(container.dataset.posBottom);
    if (isNaN(_top) || isNaN(_bot) || _bot <= _top) { _top = 13.5; _bot = 88.8; }
    // Centro horizontal de la botella en ESTA foto. Casi siempre 50, pero las
    // fotos de la sesión nueva están corridas hasta 1,2 puntos.
    var _cx = parseFloat(container.dataset.posCentro);
    if (isNaN(_cx)) _cx = 50;
    var _span = _bot - _top;
    var CM = _span * CM_POR_SPAN;
    var _base = _top + _span * CUERPO_BOT;
    var _techo = _top + _span * CUERPO_TOP;
    var _nom = _base - (MARGEN_ABAJO_CM + NOM_ALTO_CM / 2) * CM;
    var _iluC = _base - (MARGEN_ABAJO_CM + NOM_ALTO_CM + SEP_CM + ILU_CM / 2) * CM;
    var POS = { ilu: _iluC, ini: _iluC, nom: _nom, soloH: _nom, soloV: (_techo + _base) / 2 };

    // === TINTA REAL DE CADA ILUSTRACIÓN =========================================
    // Los SVG vienen en un lienzo de 600x600 pero la TINTA ocupa una fracción
    // distinta en cada uno: medido, entre 27% y 91% del lienzo. Al meter el lienzo
    // completo en la caja, la Abeja (44%) se dibujaba a la mitad del porte del Tren
    // (91%). La caja de 5,5 cm debe aplicarse a la TINTA, no al lienzo.
    // [x, y, ancho, alto] en % del lienzo del SVG. Medido rasterizando cada archivo.
    // NO re-subimos los SVG corregidos a propósito: Shopify les cambia el nombre al
    // re-subirlos y eso rompería la vista previa de todos los pedidos históricos.
    var TINTA = {
  'abeja':[23,30,44,40], 'andarivel2':[10,13,75,74], 'ballena':[6,27,81,46],
  'bandera-f1':[20,32,66,41], 'bici':[7,31,74,45], 'bici-camino':[10,39,75,39],
  'caballo':[23,7,52,85], 'cabra':[27,16,45,70], 'camara':[18,25,64,50],
  'camioneta':[10,32,80,36], 'carpintero':[27,14,45,72], 'citroneta':[7,38,88,36],
  'combi':[8,26,82,45], 'conejo':[14,26,62,48], 'elefante':[13,12,80,82],
  'f1':[6,29,87,42], 'futbol':[17,19,72,63], 'gallina':[18,12,64,75],
  'gato':[30,23,33,62], 'golf':[39,21,35,57], 'kids-castor':[20,10,59,79],
  'kids-cocodrilo':[11,15,78,71], 'kids-conejo':[19,10,61,79], 'kids-elefante':[13,10,74,79],
  'kids-jirafa':[13,11,74,78], 'kids-oso':[11,15,78,69], 'kids-patita':[16,11,68,79],
  'kids-pato':[16,10,67,79], 'kids-pinguino':[11,16,79,67], 'kids-tortuga':[10,16,79,68],
  'leon':[29,14,42,73], 'mariposa':[13,32,74,40], 'pelota-futbol':[21,17,56,69],
  'perro1':[16,30,62,39], 'perro2':[25,19,46,66], 'pez':[36,11,27,77],
  'pinguino':[21,16,48,75], 'raqueta':[31,8,36,84], 'ski':[16,6,68,88],
  'skis':[25,10,51,77], 'tabla-snowboard':[21,7,46,87], 'tiburon':[8,31,83,36],
  'tren2':[4,8,91,83], 'vespa':[15,30,68,56]
};
    function tintaDe(archivo) {
      var m = String(archivo || '').split('/').pop().split('?')[0].replace(/^ilu-/, '').replace(/\.svg$/, '');
      var t = TINTA[m];
      return t ? { x: t[0] / 100, y: t[1] / 100, w: t[2] / 100, h: t[3] / 100 }
               : { x: 0, y: 0, w: 1, h: 1 };   // sin dato: comportamiento anterior
    }

    // Achica el nombre si supera el ancho máximo real del grabado. Se mide DESPUÉS
    // de aplicar el tamaño fijo, así los nombres cortos quedan intactos.
    function ajustarAncho(el, isMini) {
      if (!el) return;
      el.style.removeProperty('--bolg-fit');
      var cont = el.offsetParent || el.parentElement;
      if (!cont) return;
      var maxPx = cont.clientWidth * (proyectar(NOM_MAX_CM) * CM) / 100;   // ancho VISIBLE
      if (!(maxPx > 0)) return;
      var vertical = /rotate\(-90deg\)/.test(el.style.transform || '');
      var w = vertical ? el.offsetHeight : el.offsetWidth;
      if (!(w > 0)) w = el.scrollWidth;
      if (w > maxPx) {
        var f = maxPx / w;
        var actual = parseFloat(getComputedStyle(el).fontSize) || 0;
        if (actual > 0) el.style.fontSize = (actual * f).toFixed(2) + 'px';
      }
    }

    function iluData(b) {
      var iy = parseFloat(b.dataset.iluY);
      return {
        nombre: b.dataset.iluNombre || '', id: b.dataset.iluId || '', img: b.dataset.iluImg || '',
        archivo: b.dataset.iluArchivo || '', x: parseFloat(b.dataset.iluX) || 50,
        y: isNaN(iy) ? null : iy,
        escala: parseFloat(b.dataset.iluEscala) || 1, rot: parseFloat(b.dataset.iluRot) || 0
      };
    }
    function fontData(b) {
      return { nombre: b.dataset.fontNombre || '', id: b.dataset.fontId || '', family: b.dataset.fontFamily || 'sans-serif', google: b.dataset.fontGoogle || '' };
    }

    var a = container.querySelector('[data-perso-ilu].is-active'); if (a) state.ilu = iluData(a);
    var fi = container.querySelector('[data-perso-font-ini].is-active'); if (fi) { state.iniFont = fontData(fi); loadGoogleFont(state.iniFont.google); }
    var fn = container.querySelector('[data-perso-font].is-active'); if (fn) { state.nameFont = fontData(fn); loadGoogleFont(state.nameFont.google); }

    var t = function () { return state.tipo.toLowerCase(); };
    function hasIlu() { return t().indexOf('lustraci') !== -1; }
    function hasIni() { return t().indexOf('iniciales') !== -1; }
    function hasNom() { return t().indexOf('nombre') !== -1; }
    function soloNombre() { return hasNom() && !hasIlu() && !hasIni(); }
    function isPerso() { return state.tipo !== ''; }
    function iniVal() { return iniInput ? iniInput.value.trim() : ''; }
    function nameVal() { return nameInput ? nameInput.value.trim() : ''; }

    function switchGallery() {
      if (isNaN(persoImgIndex)) return;
      // La galería principal de Impulse es un carrusel Flickity: hacer click en la miniatura
      // marca la miniatura activa pero no siempre mueve el carrusel. Moverlo por su API es lo confiable.
      var shows = document.querySelectorAll('.flickity-enabled');
      for (var i = 0; i < shows.length; i++) {
        var f = window.Flickity && window.Flickity.data ? window.Flickity.data(shows[i]) : null;
        if (f && f.cells && f.cells.length > 2 && shows[i].querySelector('[data-product-image-main]')) {
          var flkty = f;
          var go = function () {
            try {
              flkty.select(persoImgIndex, false, true);
              // reposition() recalcula el ancho de las celdas: sin esto Flickity aterriza en la
              // celda equivocada si la foto todavía no cargó cuando se seleccionó.
              if (flkty.reposition) flkty.reposition();
            } catch (e) {}
          };
          go();
          setTimeout(go, 150);
          setTimeout(go, 450);
          return;
        }
      }
      var th = document.querySelector('[data-product-thumb][data-index="' + persoImgIndex + '"]');
      if (th) th.click();
    }

    // Pinta las 3 capas (ilustración / iniciales / nombre) en una superficie dada
    function renderLayers(iluEl, iniEl, nameEl, isMini) {
      if (iluEl) {
        if (hasIlu() && state.ilu && state.ilu.img) {
          if (iluEl.dataset.forImg !== state.ilu.img) {
            iluEl.dataset.forImg = state.ilu.img;
            var mu = 'url("' + state.ilu.img + '")';
            iluEl.style.webkitMaskImage = mu;
            iluEl.style.maskImage = mu;
            (function (el) {
              // Los SVG sin width/height (solo viewBox) reportan naturalWidth 0 en varios
              // navegadores; el lienzo de grabado es cuadrado, así que 1/1 es el fallback.
              var probe = new Image();
              probe.onload = function () {
                el.style.aspectRatio = this.naturalWidth > 0 && this.naturalHeight > 0
                  ? this.naturalWidth + ' / ' + this.naturalHeight
                  : '1';
              };
              probe.onerror = function () { el.style.aspectRatio = '1'; };
              probe.src = el.dataset.forImg;
            })(iluEl);
          }
          // La caja de ILU_CM se aplica a la TINTA: agrandamos el elemento para que
          // la dimensión mayor de la tinta llene la caja, y lo desplazamos para que
          // el centro de la TINTA (no el del lienzo) caiga en el punto de destino.
          var tk = tintaDe(state.ilu.archivo || state.ilu.img);
          var caja = ILU_CM * CM * (state.ilu.escala || 1);
          var lado = caja / Math.max(tk.w, tk.h);
          var fx = tk.x + tk.w / 2, fy = tk.y + tk.h / 2;
          iluEl.style.left = (state.ilu.x != null && !isNaN(state.ilu.x) && state.ilu.x !== 50 ? state.ilu.x : _cx) + '%';
          iluEl.style.top = (state.ilu.y != null ? state.ilu.y : POS.ilu) + '%';
          iluEl.style.width = lado + '%';
          iluEl.style.transform = 'translate(' + (-fx * 100).toFixed(2) + '%,'
            + (-fy * 100).toFixed(2) + '%) rotate(' + (state.ilu.rot || 0) + 'deg)';
          iluEl.style.display = '';
        } else { iluEl.style.display = 'none'; }
      }
      if (iniEl) {
        if (hasIni() && iniVal()) {
          iniEl.textContent = iniVal();
          iniEl.style.fontFamily = state.iniFont ? state.iniFont.family : 'serif';
          iniEl.style.left = _cx + '%';
          iniEl.style.top = POS.ini + '%';
          iniEl.style.display = '';
        } else { iniEl.textContent = ''; iniEl.style.display = 'none'; }
      }
      if (nameEl) {
        if (hasNom() && nameVal()) {
          nameEl.textContent = nameVal();
          nameEl.style.fontFamily = state.nameFont ? state.nameFont.family : 'sans-serif';
          nameEl.style.left = _cx + '%';
          // TAMAÑO FIJO — corregido 01-ago-2026 por reporte de producción.
          //
          // La máquina graba SIEMPRE con la misma altura de letra (7 mm en las Kids).
          // Un nombre largo NO sale con letra más chica: sale más ancho, ocupando más
          // espacio hacia los lados de la botella.
          //
          // Antes acá se achicaba la letra según el largo (Math.min(6, 28/len) y
          // similares), así que TODOS los nombres terminaban midiendo lo mismo de
          // largo (10-15% del lienzo). Eso mentía: "Montserrat" se veía con letra
          // mucho más chica que "Triana", cuando en la botella real salen iguales.
          //
          // NOMBRE_CQW se calibró con el caso que producción aprobó ("Triana está
          // bien"): es exactamente el valor que la fórmula vieja daba a 6 letras.
          // Comprobado que el nombre más largo posible (12 caracteres, el máximo de
          // personalizacion_max en los 24 productos) mide 26,8% del lienzo contra
          // 30,0% que mide el cuerpo de la botella: cabe.
          //
          // Va en cqw puro, SIN clamp en px: el clamp de 18px se activaba en
          // contenedores anchos (escritorio) y volvía a achicar la letra respecto de
          // la botella. En cqw la proporción letra/botella se mantiene en cualquier
          // tamaño de pantalla y en el mini flotante.
          // El tamaño de letra es FIJO (= la caja de 1 cm del PDF), pero el PDF
          // también fija un ANCHO MÁXIMO de 6 cm. Si el nombre pasa ese ancho, el
          // láser lo achica para que quepa; antes acá crecía sin límite y por eso
          // los nombres largos se salían de la botella (reporte de Sofía, ago-2026).
          // Como la letra mide 1 cm, el máximo son NOM_MAX_CM veces el tamaño de letra.
          var NOMBRE_CQW = NOM_ALTO_CM * CM;
          if (soloNombre()) {
            if (state.orient === 'Vertical') {
              // Girado a lo largo de la botella.
              nameEl.style.top = POS.soloV + '%';
              nameEl.style.maxWidth = 'none';
              nameEl.style.transform = 'translate(-50%,-50%) rotate(-90deg)';
              nameEl.style.fontSize = NOMBRE_CQW + 'cqw';
            } else {
              // Horizontal: parte baja de la botella (un poco sobre la base).
              nameEl.style.top = POS.nom + '%';
              nameEl.style.maxWidth = 'none';
              nameEl.style.transform = 'translate(-50%,-100%)';
              nameEl.style.fontSize = NOMBRE_CQW + 'cqw';
            }
          } else {
            // Con ilustración/iniciales el nombre va en la línea de abajo, pero se
            // graba con la MISMA letra de 7 mm: mismo tamaño que solo-nombre.
            nameEl.style.top = POS.nom + '%';
            nameEl.style.maxWidth = 'none';
            nameEl.style.transform = 'translate(-50%,-100%)';
            nameEl.style.fontSize = NOMBRE_CQW + 'cqw';
          }
          // Tope de ancho: medimos el ancho real ya renderizado y, si excede
          // NOM_MAX_CM, achicamos la letra en esa proporción. Nunca la agrandamos.
          ajustarAncho(nameEl, isMini);
          nameEl.style.display = '';
        } else { nameEl.textContent = ''; nameEl.style.display = 'none'; }
      }
    }

    function updatePreview() {
      var on = isPerso();
      if (preview) preview.style.visibility = on ? 'visible' : 'hidden';
      renderLayers(pvIlu, pvIni, pvName, false);
      renderLayers(pvIluMini, pvIniMini, pvNameMini, true);
      updateMiniVisibility();
    }

    // El mini (top-center) aparece solo al personalizar Y cuando la foto grande no está a la vista (scroll)
    var mainVisible = true;
    function updateMiniVisibility() {
      if (miniCard) miniCard.hidden = !(isPerso() && !mainVisible);
    }
    (function () {
      var galleryEl = document.querySelector('[data-product-images]');
      if (galleryEl && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          mainVisible = entries[0].isIntersecting;
          updateMiniVisibility();
        }, { threshold: 0.12, rootMargin: '-72px 0px 0px 0px' }).observe(galleryEl);
      }
    })();

    function syncSections() {
      if (secIlu) secIlu.style.display = hasIlu() ? '' : 'none';
      if (secIni) secIni.style.display = hasIni() ? '' : 'none';
      if (secNom) secNom.style.display = hasNom() ? '' : 'none';
      // La orientación solo aplica cuando el nombre es el único grabado.
      if (orientWrap) orientWrap.hidden = !soloNombre();
    }

    function setProp(el, val) {
      if (!el) return;
      el.value = val == null ? '' : val;
      el.disabled = (val == null || val === '');
    }

    // buildSpec() se eliminó el 28-jul-2026. Escribía la propiedad _spec (un JSON
    // con los IDs internos) que nadie leía salvo el detector de cobro, y hacía
    // ilegible el pedido en el admin. Todo su contenido ya viaja en las
    // propiedades públicas (Tipo, Ilustración, Nombre, Fuente) y en la URL de
    // _vista_previa. Lo único que NO sobrevive es el ID canónico ILU-xxx del
    // metaobjeto: en la URL la ilustración va por nombre de archivo. Por eso los
    // nombres de archivo de grabado en el CDN son inmutables.

    // Imagen del grabado, dibujada por nuestro Worker a partir de estos datos.
    // Va como propiedad oculta para que en el pedido bodega VEA lo que pidió el
    // cliente en vez de tener que interpretar propiedades sueltas.
    var PREVIEW_BASE = 'https://bolg-tarificador.bolgenconcept-649.workers.dev/preview.svg';
    function buildPreviewUrl() {
      var p = [];
      // La foto va DIRECTA como URL del CDN: Shopify bloquea que el Worker
      // consulte el storefront, pero el CDN lo baja sin problema.
      if (container.dataset.engPhoto) p.push('img=' + encodeURIComponent(container.dataset.engPhoto));
      p.push('top=' + (container.dataset.posTop || 13.5));
      p.push('bot=' + (container.dataset.posBottom || 88.8));
      p.push('cx=' + (container.dataset.posCentro || 50));
      if (container.dataset.engColor) p.push('c=' + encodeURIComponent(container.dataset.engColor));
      if (hasIlu() && state.ilu) {
        // solo el nombre del archivo; el Worker le pone el prefijo del CDN
        var iluFile = (state.ilu.archivo || '').split('?')[0].split('/').pop();
        if (iluFile) p.push('ilu=' + encodeURIComponent(iluFile));
        if (state.ilu.nombre) p.push('iluN=' + encodeURIComponent(state.ilu.nombre));
      }
      if (hasIni() && iniVal()) {
        p.push('ini=' + encodeURIComponent(iniVal()));
        if (state.iniFont) p.push('inif=' + encodeURIComponent(state.iniFont.id));
      }
      if (hasNom() && nameVal()) {
        p.push('n=' + encodeURIComponent(nameVal()));
        if (state.nameFont) p.push('nf=' + encodeURIComponent(state.nameFont.id));
        if (soloNombre() && state.orient) p.push('o=' + encodeURIComponent(state.orient));
      }
      return p.length ? PREVIEW_BASE + '?' + p.join('&') : '';
    }

    function syncCapture() {
      var on = isPerso();
      setZoom(on);
      setProp(props.tipo, on ? state.tipo : '');
      setProp(props.flag, on ? 'Sí' : '');
      setProp(props.iluNombre, on && hasIlu() && state.ilu ? state.ilu.nombre : '');
      setProp(props.iniFontNombre, on && hasIni() && state.iniFont ? state.iniFont.nombre : '');
      setProp(props.fontNombre, on && hasNom() && state.nameFont ? state.nameFont.nombre : '');
      setProp(props.orient, on && soloNombre() ? state.orient : '');
      setProp(props.marca, on ? '1' : '');
      setProp(props.preview, on ? buildPreviewUrl() : '');
      if (iniInput) iniInput.disabled = !(on && hasIni());
      if (nameInput) nameInput.disabled = !(on && hasNom());
      if (priceBox) priceBox.hidden = !on;

      if (persoSelect) {
        var target = on ? persoOn : persoOff;
        var m = Array.prototype.find.call(persoSelect.options, function (o) {
          return o.value === target || o.value.toLowerCase().indexOf(target.toLowerCase()) !== -1;
        });
        if (m && persoSelect.value !== m.value) {
          persoSelect.value = m.value;
          persoSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    function validate(show) {
      var ok = true, nMsg = '', iMsg = '';
      if (isPerso() && hasNom()) {
        var v = nameVal();
        if (!v) { ok = false; nMsg = 'Escribe el nombre.'; }
        else if (cpLen(v) > maxChars) { ok = false; nMsg = 'Máximo ' + maxChars + ' caracteres.'; }
        else if (!NAME_RE.test(v)) { ok = false; nMsg = 'Solo letras y números.'; }
      }
      if (isPerso() && hasIni()) {
        var iv = iniVal();
        if (!iv) { ok = false; iMsg = 'Escribe las iniciales.'; }
        else if (cpLen(iv) > maxIni) { ok = false; iMsg = 'Máximo ' + maxIni + ' letras.'; }
        else if (!INI_RE.test(iv)) { ok = false; iMsg = 'Solo letras.'; }
      }
      if (nameInput) nameInput.classList.toggle('is-invalid', !!nMsg);
      if (iniInput) iniInput.classList.toggle('is-invalid', !!iMsg);
      if (nameError) { nameError.textContent = nMsg; nameError.hidden = !nMsg || !show; }
      if (iniError) { iniError.textContent = iMsg; iniError.hidden = !iMsg || !show; }
      // Ya no se escribe _validado: siempre valía "true" (el submit se bloquea
      // más abajo si ok es falso), así que era una propiedad sin información
      // ensuciando el pedido. Se quitó el 28-jul-2026.
      return ok;
    }

    function refresh(show) {
      syncSections();
      if (nameInput && nameCounter) nameCounter.textContent = String(Math.max(0, maxChars - cpLen(nameInput.value)));
      if (iniInput && iniCounter) iniCounter.textContent = String(Math.max(0, maxIni - cpLen(iniInput.value)));
      syncCapture();
      updatePreview();
      validate(!!show);
    }

    if (nameInput) {
      nameInput.addEventListener('input', function (e) {
        // No romper la escritura de tildes: (1) no tocar el valor mientras el teclado/IME
        // está componiendo; (2) normalizar a NFC para unir "a"+"´" (forma descompuesta que
        // mandan algunos teclados) en "á" ANTES de filtrar — si no, el acento suelto no
        // estaba en la lista permitida y se borraba, dejando solo "a".
        if (e && e.isComposing) return;
        var clean = nameInput.value.normalize('NFC').replace(NAME_STRIP, '');
        if (clean !== nameInput.value) nameInput.value = clean;
        refresh(false);
      });
      nameInput.addEventListener('blur', function () { refresh(true); });
    }
    if (iniInput) {
      iniInput.addEventListener('input', function (e) {
        if (e && e.isComposing) return;
        var clean = iniInput.value.normalize('NFC').replace(INI_STRIP, '').toUpperCase();
        if (clean !== iniInput.value) iniInput.value = clean;
        refresh(false);
      });
      iniInput.addEventListener('blur', function () { refresh(true); });
    }

    function wireChips(btns, onPick) {
      Array.prototype.forEach.call(btns, function (btn) {
        btn.addEventListener('click', function () {
          Array.prototype.forEach.call(btns, function (b) {
            b.classList.toggle('is-active', b === btn);
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          onPick(btn);
          refresh(false);
        });
      });
    }

    Array.prototype.forEach.call(tipoBtns, function (btn) {
      btn.addEventListener('click', function () {
        Array.prototype.forEach.call(tipoBtns, function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        state.tipo = btn.dataset.persoTipo;
        refresh(false);
        if (state.tipo !== '') switchGallery();
      });
    });

    wireChips(iluBtns, function (b) { state.ilu = iluData(b); });
    wireChips(iniFontBtns, function (b) { state.iniFont = fontData(b); loadGoogleFont(state.iniFont.google); });
    wireChips(nameFontBtns, function (b) { state.nameFont = fontData(b); loadGoogleFont(state.nameFont.google); });
    wireChips(orientBtns, function (b) { state.orient = b.dataset.persoOrient || 'Horizontal'; });

    // ---- Marcador PERSONALIZADO para bodega: al personalizar, se agrega también un ítem oculto
    //      (SKU/código de barra PERSONALIZADO) para que en el taller escaneen y confirmen el grabado.
    var markerVariantId = parseInt(container.dataset.markerVariant, 10);
    function readSentProps() {
      var props = {};
      Array.prototype.forEach.call(form.querySelectorAll('[name^="properties["]'), function (el) {
        if (el.disabled) return;
        var m = el.name.match(/^properties\[(.+)\]$/);
        if (m) props[m[1]] = el.value;
      });
      return props;
    }
    function cartVariantId() { var e = form.querySelector('[name="id"]'); return e ? e.value : ''; }
    function cartQty() { var e = form.querySelector('[name="quantity"]'); var n = e ? parseInt(e.value, 10) : 1; return n > 0 ? n : 1; }
    function announceAdded(product) {
      form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { product: product, addToCartBtn: form.querySelector('[name="add"], .add-to-cart') }, bubbles: true
      }));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }
    function postItems(items) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); });
    }
function addWithMarker() {
  var vid = cartVariantId();
  if (!vid) return Promise.reject();

  var q = cartQty();

  var itemsToAdd = [
    { id: vid, quantity: q, properties: readSentProps() },
    { id: markerVariantId, quantity: q }
  ];

  // Incluir accesorios seleccionados en "Completa tu aventura"
  var adventureBundle = document.querySelector('[data-adventure-bundle]');

  if (adventureBundle) {
    var adventureItems = adventureBundle.querySelectorAll('[data-adventure-item]');

    Array.prototype.forEach.call(adventureItems, function (item) {
      var checkbox = item.querySelector('[data-adventure-checkbox]');
      var select = item.querySelector('[data-adventure-select]');

      if (checkbox && checkbox.checked && select && select.value) {
        itemsToAdd.push({
          id: Number(select.value),
          quantity: 1
        });
      }
    });
  }

  return postItems(itemsToAdd).then(function (data) {
    announceAdded(data.items ? data.items[0] : data);
  });
}
    function addFallback() {
      // Nunca romper el add: si el flujo con marcador falla, agrega solo la botella (o submit normal).
      var vid = cartVariantId();
      postItems([{ id: vid, quantity: cartQty(), properties: readSentProps() }])
        .then(function (data) { announceAdded(data.items ? data.items[0] : data); })
        .catch(function () { try { form.submit(); } catch (e) {} });
    }

    if (form) {
      form.addEventListener('submit', function (evt) {
        syncCapture();
        if (!validate(true)) {
          evt.preventDefault();
          evt.stopPropagation();
          var bad = container.querySelector('.is-invalid');
          if (bad) bad.focus();
          return;
        }
        if (isPerso() && markerVariantId) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          addWithMarker().catch(addFallback);
        }
      }, true);
    }

    document.addEventListener('variant:change', function () { setTimeout(syncCapture, 0); });

    refresh(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
